import { render, staticRenderFns } from "./markupPay.vue?vue&type=template&id=2f078fcc&scoped=true"
import script from "./markupPay.vue?vue&type=script&lang=js"
export * from "./markupPay.vue?vue&type=script&lang=js"
import style0 from "./markupPay.vue?vue&type=style&index=0&id=2f078fcc&prod&lang=scss&scoped=true"
import style1 from "./markupPay.vue?vue&type=style&index=1&id=2f078fcc&prod&lang=scss"
import style2 from "./markupPay.vue?vue&type=style&index=2&id=2f078fcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f078fcc",
  null
  
)

export default component.exports